import apiClient from './apiClient';

const settingsAPI = {
  // Theme
  getTheme: () => apiClient.get('/api/settings/theme'),

  // Global settings (SuperAdmin)
  getGlobalSettings: () => apiClient.get('/api/settings/global'),
  updateGlobalSettings: (data) => apiClient.put('/api/settings/global', data),

  // Company settings
  getCompanySettings: (companyId) => apiClient.get(`/api/settings/company/${companyId || ''}`),
  updateCompanySettings: (companyId, data) => apiClient.put(`/api/settings/company/${companyId || ''}`, data),

  // Document/PDF branding
  getDocumentBranding: (companyId) => apiClient.get(`/api/settings/document-branding/${companyId || ''}`),
  updateDocumentBranding: (companyId, data) => apiClient.put(`/api/settings/document-branding/${companyId || ''}`, data),
};

export default settingsAPI;
